module.exports = __webpack_public_path__ + "img/circle-x.4e10bb0a.svg";